import React, { useState } from "react";
import "./annuity.scss";
import Buttons from "../../atoms/Buttons";
import { Card, Col, Row } from "react-bootstrap";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useNavigate } from "react-router-dom";

const Annuity = (props) => {
  const [annuityProvider, setAnnuityProvider] = useState("");
  const navigate = useNavigate();

  const handleAccountInputChange = (e) => {
    setAnnuityProvider(e.target.value);
  };
  const handleBack = () => {
    props.makeInitialStepper(false, 34, { isAnnuityHowMuchCash: true }, true);
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER;
    let takeGuaranteedIncomeAnnuity = {
      annuityProvider: annuityProvider,
    };
    let payload = {
      currentStep,
      choiceCategory: { takeGuaranteedIncomeAnnuity },
    };
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_ANNUITY_PROVIDER,
      payload, // eslint-disable-line
    );
  };
  return (
    <Card className="application-step">
      <Card.Body className="confirm-your-choices">
        <div className="annuity-section">
          <div>
            <h2 className="heading">Annuity details</h2>
            <p>
              You can buy an annuity from an insurance company or specialist
              provider. TPT doesn&apos;t provide annuities but you can use our
              quick quote tool for an estimate (in the Plan your future tool).
              Visit{" "}
              <a
                href="https://www.moneyhelper.org.uk/en/pensions-and-retirement/taking-your-pension"
                className="moneyhelper-link text-decoration-underline"
              >
                <b>MoneyHelper</b>
              </a>{" "}
              for a more detailed quote or seek guidance or independent advice.
            </p>
            <p>
              There are many types of annuity to choose from, and the amount you
              get from each can vary, especially at older ages or if you qualify
              for an &apos;enhanced&apos; annuity if you have health conditions.
            </p>
            <p>
              Annuity quotes are typically only valid for a fixed period. You
              may require an updated quote or to shop around again closer to
              your payment date, especially if you are awaiting a final
              contribution to be paid into your pension.
            </p>
            <p>Please advise the name of your annuity provider</p>
          </div>
          <div className="input-section">
            <p>Annuity provider </p>
            <input
              type="text"
              className="input-text large-input"
              value={annuityProvider}
              onChange={handleAccountInputChange}
              maxLength={40}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^a-zA-Z \-_]/g, "");
              }}
              placeholder="Annuity provider name"
            />
          </div>
          <div className="annuity-provider">
            <span className="fw-bold">Important: </span> Your tax-free cash will
            be paid at the same time as your annuity provider. Kindly ask your
            provider or financial adviser to share full payment instructions
            with us, so that we can process your application. You can upload the
            details at{" "}
            <span
              className="getintouch-link fw-bold"
              onClick={() => navigate("/get-in-touch/")}
            >
              get in touch
            </span>
            .
          </div>
          <Row className="button-container">
            <Col md={6}>
              {" "}
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />
            </Col>
            <Col md={6} className="text-end">
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
                disabled={annuityProvider !== "" ? false : true}
              />
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};
export default Annuity;
